"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.FieldWrapper = void 0;

var _react = _interopRequireWildcard(require("react"));

var _coreInteractiveIcon = _interopRequireDefault(require("@legacy-vfuk/core-interactive-icon"));

var _reactI18next = require("react-i18next");

var Styled = _interopRequireWildcard(require("./styles/FieldWrapper.style"));

var _HelpText = _interopRequireDefault(require("./components/HelpText"));

var _StateText = _interopRequireDefault(require("./components/StateText"));

var _constants = require("./constants");

var _getDescribedByIds = require("./utils/getDescribedByIds");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var FieldWrapper = /*#__PURE__*/function (_PureComponent) {
  _inherits(FieldWrapper, _PureComponent);

  var _super = _createSuper(FieldWrapper);

  function FieldWrapper() {
    var _this;

    _classCallCheck(this, FieldWrapper);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      isMasked: true
    };

    _this.handleInputVisibilityClick = function () {
      _this.setState({
        isMasked: !_this.state.isMasked
      });
    };

    return _this;
  }

  _createClass(FieldWrapper, [{
    key: "showStateText",
    value: function showStateText() {
      if (this.props.stateText && this.props.state !== 'disabled') {
        return !!this.props.state;
      }

      return false;
    }
  }, {
    key: "childrenAdditionalProps",
    get: function get() {
      var _this$props$children;

      var additionalProps = {};

      if (this.props.required) {
        additionalProps.required = true;
      }

      if (((_this$props$children = this.props.children) === null || _this$props$children === void 0 ? void 0 : _this$props$children.props.type) === 'password' && !this.state.isMasked) {
        additionalProps.type = 'text';
      }

      var ariaDescribedByIds = (0, _getDescribedByIds.getAriaDescribedByIds)(this.props.formElementId, this.props.helpText, this.props.stateText, this.props.subText);
      if (ariaDescribedByIds.length) additionalProps.describedBy = ariaDescribedByIds;
      return additionalProps;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$children2;

      /**
       * If the children has a root type of 'password'
       */
      var isTypePassword = ((_this$props$children2 = this.props.children) === null || _this$props$children2 === void 0 ? void 0 : _this$props$children2.props.type) === 'password';
      return /*#__PURE__*/_react["default"].createElement(Styled.FieldWrapper, {
        width: this.props.width
      }, /*#__PURE__*/_react["default"].createElement(Styled.TopLabelWrapper, {
        showLabel: this.props.showLabel
      }, /*#__PURE__*/_react["default"].createElement(Styled.FlexIndicatorContainer, {
        showLabel: this.props.showLabel
      }, /*#__PURE__*/_react["default"].createElement(Styled.Label, {
        as: this.props.renderAsLabel ? 'label' : 'div',
        htmlFor: this.props.renderAsLabel ? this.props.formElementId : undefined,
        isTypePassword: isTypePassword,
        state: this.props.state,
        showLabel: this.props.showLabel
      }, this.props.label), this.props.showLabel ? [this.props.optional || this.props.required ? /*#__PURE__*/_react["default"].createElement(Styled.OptionalOrRequiredLabel, {
        "aria-hidden": true,
        key: "0"
      }, this.props.optional ? this.props.t('Optional') : this.props.t('Required')) : null, isTypePassword ? /*#__PURE__*/_react["default"].createElement(_coreInteractiveIcon["default"], {
        srText: "".concat(this.state.isMasked ? this.props.t('Show') : this.props.t('Hide'), " ").concat(this.props.label.toLowerCase()),
        name: this.state.isMasked ? 'show-password' : 'hide-password',
        size: 2,
        isResponsive: false,
        onClick: this.handleInputVisibilityClick,
        key: "1"
      }) : null] : null), this.props.subText ? /*#__PURE__*/_react["default"].createElement(Styled.SubText, {
        id: "".concat(this.props.formElementId, "-").concat(_constants.SUB_TEXT),
        state: this.props.state
      }, this.props.subText) : null), /*#__PURE__*/_react["default"].createElement(Styled.InputWrapper, null, /*#__PURE__*/(0, _react.cloneElement)(this.props.children, this.childrenAdditionalProps)), this.showStateText() ? /*#__PURE__*/_react["default"].createElement(_StateText["default"], {
        state: this.props.state,
        stateText: this.props.stateText,
        formElementId: this.props.formElementId,
        validateOn: this.props.validateOn
      }) : null, this.props.helpText || this.props.helpLink ? /*#__PURE__*/_react["default"].createElement(_HelpText["default"], {
        state: this.props.state,
        formElementId: this.props.formElementId,
        helpText: this.props.helpText,
        helpLink: this.props.helpLink
      }) : null);
    }
  }]);

  return FieldWrapper;
}(_react.PureComponent);

exports.FieldWrapper = FieldWrapper;
FieldWrapper.defaultProps = {
  showLabel: true,
  width: 'default',
  renderAsLabel: true
};
FieldWrapper.displayName = "FieldWrapper";

var _default = (0, _reactI18next.withTranslation)()(FieldWrapper);

exports["default"] = _default;
//# sourceMappingURL=FieldWrapper.js.map